import {Component, OnInit, NgZone} from '@angular/core';
import {AppService} from 'src/app/services/app.services';
import {ActivatedRoute} from '@angular/router';
import * as _ from 'underscore';
import * as $ from 'jquery';
import fp from '../../lib';
import {ModalService} from '../../components/_modal';
import {ThemeService} from '../../themes';

@Component({
  selector: 'app-categorylist',
  templateUrl: './categorylist.component.html',
  styleUrls: ['./categorylist.component.css']
})
export class CategorylistComponent implements OnInit {
  files = [];
  skip = false;
  categories = [];
  photos = [];
  errorText = '';
  pageBanner = '';
  currGroup = '_0';
  currentPageNum = 0;
  currentPhoto = 0;
  currentPageData : any = {};
  // currentPhotoData: Photo;
  currentPhotoData : any = {};
  guidancePhoto : any = {};
  diid : number;
  savedAnswers = [];
  gettingPhotos = false;
  gettingQuestions = true;
  moveNext = false;
  nextGroup = '_1';
  pageData : any = {};
  pageIsDirty = false;
  pageText = '';
  showLoading = false;
  loading = {};
  showNext = true;
  showPage = false;
  showPhotos = false;
  showQuestions = false;
  showError = false;
  showErrorText = false;
  showEnd = false;
  savingQuestions = false;
  validators = ['-'];
  currLanguage = '';
  photoLat : number;
  photoLang : number;
  isGeoChecked : boolean;
  questionNeedsLocation : boolean = false;
  locationErrorText : string = "Location Services is required to be enabled to complete this survey. Location services can be enabled for this website in your browser settings.";
  roundedButtons : boolean = true;
  langLookUps = {
    'es': 'Spanish',
    'en': 'English',
    "yue": "Cantonese (Traditional)",
    "lzh": "Chinese (Literary)",
    "zh-Hans": "Chinese Simplified",
    "zh-Hant": "Chinese Traditional",
    "fil": "Filipino",
    "vi": "Vietnamese",
    "fr": "French",
    "fr-ca": "French (Canada)",
    "ko": "Korean",
    "ar": "Arabic",
    "de": "German",
    "ru": "Russian"
  }


  constructor (
    private appServ : AppService,
    private route : ActivatedRoute,
    private modalService : ModalService,
    private themeService : ThemeService,
    private ngZone: NgZone
  ) {}

  ngOnInit () : void {
    const token = this.route.snapshot.params.token;
    //let languages = 'en-us';
    this.appServ.insuredToken = token;
    this.appServ.origin = this.route.snapshot.queryParams.origin;
    if (token !== undefined) {
      this.getUISkin();
    } else {
      document.location.href = '/landing';
    }
  }

  checkGeoLocation () {

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((position) => {
        this.photoLang = position.coords.longitude;
        this.photoLat = position.coords.latitude;
        this.isGeoChecked = true;
        this.questionNeedsLocation = false;
        //  console.log('curPOS1:' , position.coords);
        //   console.log('lat:', this.photoLat);
        //   console.log('long: ', this.photoLang);
      }, (error) => {
        // console.log(error);
        this.isGeoChecked = false;
        if (this.pageData.locationServices == 2 && !this.questionHaveGeo()) {
          this.errorText = this.locationErrorText;
          this.showError = true;
        }

      });
    } else {
      this.isGeoChecked = false;
    }
  }

  getQuestion (obj) {
    this.guidancePhoto = {};
    this.showQuestions = false;
    this.pageIsDirty = false;
    this.appServ.questions(obj).subscribe(question => {
      this.showQuestions = true;
      // console.log('data: ', question);
      // console.log('page dirty: ', this.pageIsDirty);
      this.pageData = question;
      // console.log('pageData: ', this.pageData.questionGroups[0].questions);
      for (let qg = 0; qg < this.pageData.questionGroups.length; qg++) {
        this.pageData.questionGroups[qg].visible = false;
        this.updateFunctionData(this.pageData.questionGroups[qg].questions);
        let showGroup = 0;
        for (let d = 0; d < this.pageData.questionGroups[qg].questions.length; d++) {
          // this.pageData.questionGroups[qg].questions[d].visible = false;
          if (this.pageData.questionGroups[qg].questions[d].guidanceImages.length > 0) {
            this.pageData.questionGroups[qg].questions[d].currGuidePhoto = 0;
            //this.loadGuidePhoto(0,qg,d);
          }
          const visFunc = this.pageData.questionGroups[qg].questions[d].visibilityFunction;
          if ((this.pageData.questionGroups[qg].questions[d].value !== '' && this.pageData.questionGroups[qg].questions[d].value !== null) || (this.pageData.questionGroups[qg].questions[d].questionType == 6)) {
            this.pageIsDirty = true;
          }

          if (visFunc) {
            const retTF = this.parseFunction(visFunc, this.pageData.functionData);
            if (retTF) {
              showGroup += showGroup + 1;
            }

            this.pageData.questionGroups[qg].questions[d].visible = retTF;

          } else {

            this.pageData.questionGroups[qg].visible = true;
            this.pageData.questionGroups[qg].questions[d].visible = true;

          }
          if (this.pageData.questionGroups[qg].questions[d].locationRequired == true) {
            this.questionNeedsLocation = true;
          }
        }

        if (showGroup > 0) {
          this.pageData.questionGroups[qg].visible = true;
        }
      }
      if ((this.pageData.locationServices == 1 || this.pageData.locationServices == 2) && !this.isGeoChecked) {
        this.checkGeoLocation();
      }


    }, error => {
      this.showQuestions = false;
      if (error.status == 404) {
        this.appServ.getSpecialPage('FINISHEDQUESTIONNAIREPAGE').subscribe(pageTxt => {
          // console.log('page content: ', pageTxt);
          this.showPage = true;
          this.pageText = pageTxt.pageData;

        }, error => {
          this.showPage = true;
          this.pageText = error.error.text;
          //    console.log(error.error.text);
        });
      } else if (error.status == 401) {
        this.appServ.getSpecialPage('TOKENEXPIRATIONPAGE').subscribe(pageTxt => {
          this.showPage = true;
          this.pageText = pageTxt.pageData;

        }, error => {
          this.showPage = true;
          this.pageText = error.error.text;
          //     console.log(error.error.text);
        });
      } else if (error.status == 410) {
        window.location.href = window.location.href.replace(this.appServ.insuredToken, error.error);
      } else {
        this.showError = true;
        this.errorText = "There was an issue getting the next question. Please refresh the page and try again.";
      }
    });
  }

  questionHaveGeo () {
    let retVal = false;
    for (let qg = 0; qg < this.pageData.questionGroups.length; qg++) {
      const qTotal = this.pageData.questionGroups[qg].questions.length;
      for (let i = 0; i < qTotal; i++) {
        if (this.pageData.questionGroups[qg].questions[i].questionType == 5 && this.pageData.questionGroups[qg].questions[i].value.length > 0) {
          retVal = true;
        }
      }
    }
    return retVal;
  }

  getUISkin () {
    this.appServ.getUiSkin().subscribe(skin => {
      if (skin.styleName == 'Default') {
        this.themeService.setTheme('red');
      } else if (skin.styleName == 'DefaultBlue') {
        this.themeService.setTheme('blue');
      } else if (skin.styleName == 'DefaultWhite') {
        this.themeService.setTheme('white');
      } else if (skin.styleName == 'StateFarm') {
        this.themeService.setTheme('statefarm');
      } else if (skin.styleName == 'Westfield') {
        this.themeService.setTheme('westfield');
      }

      this.roundedButtons = this.themeService.getActiveTheme().settings.roundedButtons;

      this.pageBanner = skin.bannerImage;
      if (window.navigator.language != '' || window.navigator.language != null) {
        this.currLanguage = window.navigator.language;
      }

      this.getQuestion({language: this.currLanguage, from: this.appServ.origin});
    });

  }

  nextQuestion (dir : number) {
    window.scrollTo(0, 0);
    //  console.log('q grp: ', this.pageData.questionGroups[this.currGroup[1]]);
    this.showError = false;
    let q = [];
    for (let qg = 0; qg < this.pageData.questionGroups.length; qg++) {
      const qTotal = this.pageData.questionGroups[qg].questions.length;
      for (let i = 0; i < qTotal; i++) {


        if ((this.pageData.locationServices == 2) && (this.isGeoChecked == false) && (!this.questionHaveGeo())) {
          this.errorText = this.locationErrorText;
          this.showError = true;
          return false;
        }

        const qq : any = {};
        let v = this.pageData.questionGroups[qg].questions[i].value;
        if (this.pageData.questionGroups[qg].questions[i].value == null) {
          v = '';
        }
        qq.value = v;
        qq.questionName = this.pageData.questionGroups[qg].questions[i].questionName;
        qq.questionText = this.pageData.questionGroups[qg].questions[i].questionText;
        qq.questionType = this.pageData.questionGroups[qg].questions[i].questionType;
        qq.visibilityFunction = this.pageData.questionGroups[qg].questions[i].visibilityFunction;
        qq.guidanceImages = this.pageData.questionGroups[qg].questions[i].guidanceImages;
        qq.guidanceImageDisplayType = this.pageData.questionGroups[qg].questions[i].guidanceImageDisplayType;
        q.push(qq);
      }
    }

    // {value:q.value,questionText:q.questionText,questionType:q.questionType,visibilityFunction:null,guidanceImages:q.guidanceImages,guidanceImageDisplayType:q.guidanceImageDisplayType,questionName:q.questionName}
    //  console.log('saving: ', {questions: q, buttonPushed: dir, pageName: this.pageData.pageName});
    
    this.getQuestion({questions: q, buttonPushed: dir, pageName: this.pageData.pageName, language: this.currLanguage, referer: 'na', from: this.appServ.origin, locationServicesActive: this.isGeoChecked});
  }

  saveAnswer (evt) {
    // console.log('save answer: ', evt);
    const id = evt.target.id.split('_');
    this.currGroup = evt.target.name.split('_');
    this.nextGroup = this.currGroup[1] + 1;

    this.pageIsDirty = true;
    // console.log('group: ', this.currGroup[1]);

    let val : any = false;
    if (evt.target.type == 'checkbox') {
      // console.log('checkbox: ', evt.target.checked);
      val = evt.target.checked;
    } else if (this.pageData.questionGroups[this.currGroup[1]].questions[id[1]].questionType == 1) {
      // const today = new Date();
      let t = evt.target.value.split(':');
      let ts = ' PM';
      // let todayMilli = new Date(today.getFullYear(), today.getMonth(), today.getDate(),t[0], t[1]);
      if (t[0] <= 11) {
        ts = ' AM';
        if (t[0] == '00') {
          t[0] = 12;
        }
      }
      let newTime = t[0] + ':' + t[1] + ts;
      // console.log('raw val: ', evt.target.value + ts);
      // console.log('str to float: ', this.timeStringToFloat(newTime));
      // console.log('to ms: ', this.convertToMs(this.timeStringToFloat(newTime)));

      val = this.convertToMs(this.timeStringToFloat(newTime));
    } else {
      val = evt.target.value;
    }

    this.pageData.questionGroups[this.currGroup[1]].questions[id[1]].value = val;

    // console.log('q val: ' , this.pageData.questionGroups[this.currGroup[1]].questions[id[1]].value);
    this.updateFunctionData(this.pageData.questionGroups[this.currGroup[1]].questions);

    for (let qg = 0; qg < this.pageData.questionGroups.length; qg++) {
      let showGroup = 0;

      // console.log('searching group: ', this.pageData.questionGroups[qg].groupName);
      // tslint:disable-next-line:prefer-for-of
      for (let d = 0; d < this.pageData.questionGroups[qg].questions.length; d++) {
        const visFunc = this.pageData.questionGroups[qg].questions[d].visibilityFunction;
        // console.log('vizfunc: ', visFunc);
        if (visFunc) {
          let retTF = this.parseFunction(visFunc, this.pageData.functionData);
          if (retTF) {
            showGroup += 1;
          }
          this.pageData.questionGroups[qg].questions[d].visible = retTF;
          
          // console.log('retTF: ', retTF);
        } else {
          showGroup += 1;
        }
      }
      if (showGroup > 0) {
        this.pageData.questionGroups[qg].visible = true;
      } else {
        this.pageData.questionGroups[qg].visible = false;
      }
    }

  }

  changeLang (evt : any) {

  }

  parseFunction (func : string, data : any) {
    const retEvals = [];
    const fdObj = {};
    for (let a = 0; a < data.length; a++) {
      if (data[a].key) {
        const k = data[a].key;
        const v = data[a].value;
        fdObj[k] = v;
      }
    }
    const tf = fp.evaluate(func, fdObj);
    return tf;
  }

  updateFunctionData (questions : any) {
    for (let qq = 0; qq < questions.length; qq++) {
      // console.log('q/v: ', questions[qq].questionName + ' ' + questions[qq].value);
      if ((questions[qq].questionType == 7) && (questions[qq].value === null)) {
        //  console.log('val is null');
        questions[qq].value = false;
      }
      const fpObj = {key: questions[qq].questionName, value: questions[qq].value};
      let found = false;
      for (let fd = 0; fd < this.pageData.functionData.length; fd++) {
        if (this.pageData.functionData[fd].key == fpObj.key) {
          this.pageData.functionData[fd].value = fpObj.value;
          found = true;
        }
      }

      // console.log('found? ', found);
      if (!found) {
        this.pageData.functionData.push(fpObj);
      }
    }

  }

  fileSelect (evt) {
    const maxDimension = 1024;
    const input = evt.target;
    let groupIndex = input.attributes["data-groupindex"].value;
    let questionIndex = input.attributes["data-questionindex"].value;
    let questionName = input.attributes["data-questionname"].value;

    this.loading[questionName] = 0;

    for (let i = 0; i < evt.target.files.length; i++) {
      const file = evt.target.files[i];

      this.showLoading = true;
      this.loading[questionName]++;

      if (!file.type.match('image/jpeg')) {
        if (this.loading[questionName] > 0) {
          this.loading[questionName]--;
        }

        if (i == evt.target.files.length - 1) {
          this.showLoading = false;
          this.loading[questionName] = 0;
        }

        continue;
      }

      let that = this;

      let uploadBlob = (function (blob) {
        const upload : any = {};
        upload.InspectionId = this.pageData.inspectionId;
        upload.Image = blob;
        upload.Extension = 'jpg';
        upload.QuestionName = questionName;
        upload.Latitude = this.photoLat;
        upload.Longitude = this.photoLang;

        this.appServ.uploadPhotos(upload).subscribe(
          photo => {
            this.pageData.questionGroups[groupIndex].questions[questionIndex].value.push(photo);
          },
          error => {
            console.log(error);
            this.showErrorText = true;
            this.errorText = error.error.text;
          },
          () => {
            this.ngZone.run(() => {
              if (this.loading[questionName] > 0) {
                this.loading[questionName]--;
              }

              if (i == evt.target.files.length - 1) {
                this.showLoading = false;
                this.loading[questionName] = 0;
              }
            });
            
          }
        );
      }).bind(this);

      let reader = new FileReader();

      reader.onload = function (e) {
        const img = document.createElement('img');

        img.onload = function (e) {
            const img = e.target as HTMLImageElement;
            const max = Math.max(maxDimension, img.width, img.height);

            if (max != maxDimension) {
                const scale = maxDimension / max;
                const width = max === img.width ? maxDimension : img.width * scale;
                const height = max === img.height ? maxDimension : img.height * scale;
                const canvas = document.createElement('canvas');

                canvas.width = width;
                canvas.height = height;
          
                const ctx = canvas.getContext('2d');

                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(uploadBlob, file.type, 0.9);
            } else {
              uploadBlob(file);
            }
        };

        img.src = e.target.result as string;
      };

      reader.readAsDataURL(file);
    }
  }

  validateText (txtinput) {
    // console.log(txtinput.target.id);
    // console.log(txtinput.target.name);
    const qStr = txtinput.target.id.split('_');
    const qId = qStr[1];
    const grpStr = txtinput.target.name.split('_');
    const grpId = grpStr[1];
    const txtval : number = txtinput.target.value.length;
    const showWarning = false;
    if (this.pageData.questionGroups[grpId].questions[qId].maxLength === null) {
      this.pageData.questionGroups[grpId].questions[qId].maxLength = 1000;
    }
    if (this.pageData.questionGroups[grpId].questions[qId].minLength === null) {
      this.pageData.questionGroups[grpId].questions[qId].minLength = 0;
    }

    // tslint:disable-next-line:max-line-length
    if (txtval >= this.pageData.questionGroups[grpId].questions[qId].minLength && txtval <= this.pageData.questionGroups[grpId].questions[qId].maxLength) {
      this.saveAnswer(txtinput);
      this.showErrorText = false;
      this.errorText = '';
    } else {
      this.saveAnswer(txtinput);
      this.showErrorText = true;
      // tslint:disable-next-line:max-line-length
      this.errorText = 'Please enter between ' + this.pageData.questionGroups[grpId].questions[qId].minLength + ' and ' + this.pageData.questionGroups[grpId].questions[qId].maxLength + ' characters.';
    }
  }

  loadGuidePhoto (photo, grp, q) {
    let photoToGet = 0;
    this.pageData.questionGroups[grp].questions[q].currGuidePhoto = this.pageData.questionGroups[grp].questions[q].currGuidePhoto + photo;
    // console.log('curPhoto: ', this.pageData.questionGroups[grp].questions[q].currGuidePhoto);
    if (this.pageData.questionGroups[grp].questions[q].currGuidePhoto >= 0 && this.pageData.questionGroups[grp].questions[q].currGuidePhoto < this.pageData.questionGroups[grp].questions[q].guidanceImages.length - 1) {
      // console.log('current photo between 0 && ' + (this.pageData.questionGroups[grp].questions[q].guidanceImages.length-1));
      photoToGet = this.pageData.questionGroups[grp].questions[q].currGuidePhoto;
    } else if (this.pageData.questionGroups[grp].questions[q].currGuidePhoto > this.pageData.questionGroups[grp].questions[q].guidanceImages.length - 1) {
      // console.log('curPhoto is greater than guidance photo length:')
      photoToGet = 0;
      this.pageData.questionGroups[grp].questions[q].currGuidePhoto = 0;
    } else if (this.pageData.questionGroups[grp].questions[q].currGuidePhoto == this.pageData.questionGroups[grp].questions[q].guidanceImages.length - 1) {
      // console.log('curPhoto is the same as guidance photo length');
      photoToGet = this.pageData.questionGroups[grp].questions[q].currGuidePhoto;
    } else if (this.pageData.questionGroups[grp].questions[q].currGuidePhoto < 0) {
      // console.log('curPhoto is less than 0');
      this.pageData.questionGroups[grp].questions[q].currGuidePhoto = this.pageData.questionGroups[grp].questions[q].guidanceImages.length - 1;
      photoToGet = this.pageData.questionGroups[grp].questions[q].currGuidePhoto;
    } else {
      // console.log('should not get here...');
      // console.log('curPhoto: ', this.currentPhoto);
    }

    // console.log('photo to load:', photoToGet);

    this.guidancePhoto = this.pageData.questionGroups[grp].questions[q].guidanceImages[photoToGet];
    // console.log(this.guidancePhoto);
  }

  deletePhoto (evt) {
    this.pageData.questionGroups[evt.g].questions[evt.q].value.splice(evt.place, 1);
  }

  updateSkipReason (evt) {
    this.moveNext = true;
    this.currentPhotoData.skipReason = evt.target.value;
    this.currentPhotoData.UnableToComplete = 'true';
  }

  openModal (id : string) {
    this.modalService.open(id);
  }

  closeModal (id : string) {
    this.modalService.close(id);
  }

  timeStringToFloat (time) {
    const hoursMinutes = time.split(/[.:]/);
    const hours = parseInt(hoursMinutes[0], 10);
    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
  }

  convertToMs (timefloat) {
    // Get the minutes portion
    let remainder = timefloat % 1;

    // Convert into ms
    let minutes = remainder * 100 * 60 * 1000;

    // Get the number of hours and convert to ms 
    let hours = (timefloat - remainder) * 60 * 60 * 1000;

    return minutes + hours;
  }

  setLanguage (evt : any) {
    this.currLanguage = evt;
    this.getQuestion({language: this.currLanguage, from: this.appServ.origin});
  }

  setActive (str : string) {
    let ret = false;
    if (str == this.currLanguage) {
      ret = true;
    }
    return ret;
  }

  lookUpLnaguage (str : string) {
    let ret = str;
    if (this.langLookUps[str]) {
      ret = this.langLookUps[str];
    }
    return ret;
  }
}
